import CarrotBanner from '@acorn-portal/shared/src/components/banner/CarrotLanderBanner';
import { useAppDispatch } from '@acorn-portal/shared/src/hooks/reduxHook';
import { UnsupportedChangeReferralMessage } from '@acorn-portal/shared/src/pages/mta/components/unsupported-change-referral-message';
import { clearMidTermAdjustmentDetails } from '@acorn-portal/shared/src/store/midTermAdjustment.slice';
import { resetApiMTA } from '@acorn-portal/shared/src/store/midTermAdjustmentAPI.sclice';
import { CARROT_CONTACT_NUMBER } from '@acorn-portal/shared/src/utils/constants';
import Home from '@mui/icons-material/Home';
import { Box, Button, Fade, Paper } from '@mui/material';
import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router';

const MtaReferralPage: FC = () => {
	const navigate = useNavigate();
	const dispatch = useAppDispatch();

	useEffect(() => {
		dispatch(clearMidTermAdjustmentDetails());
		dispatch(resetApiMTA());
	}, [dispatch]);

	return (
		<Paper
			elevation={1}
			sx={{
				borderRadius: '8px',
			}}
		>
			<Fade in>
				<Box>
					<CarrotBanner
						text={
							<Box
								sx={(theme) => ({
									[theme.breakpoints.down('md')]: { fontSize: '1.4rem' },
									[theme.breakpoints.down('sm')]: {
										fontSize: '1rem',
									},
								})}
							>
								We can&apos;t provide a quote for this change
							</Box>
						}
					/>
					<Box
						sx={{
							display: 'flex',
							justifyContent: 'center',
							flexDirection: 'column',
							alignItems: 'center',
							textAlign: 'center',
							px: 2,
							'& > *': { mb: 3 },
						}}
					>
						<Box
							sx={(theme) => ({
								mt: 4,
								mx: '10%',
								'& > *': { mb: 3 },
								[theme.breakpoints.down('md')]: {
									mx: 'unset',
								},
							})}
						>
							<UnsupportedChangeReferralMessage
								phoneNumber={CARROT_CONTACT_NUMBER}
								openingHours='Mon-Sat – 9.00am – 5.30pm, Sun – Closed'
							/>
						</Box>
						<Button
							startIcon={<Home />}
							size='large'
							variant='contained'
							onClick={() => {
								navigate('/portal/home');
								return null;
							}}
						>
							Return to homepage
						</Button>
						<Box sx={{ margin: 2 }} />
					</Box>
				</Box>
			</Fade>
		</Paper>
	);
};

export default MtaReferralPage;
